import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoading: false,
  errors: null,
  data: {}
};

export const slice = createSlice({
  name: 'headerConfig',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoading = initialState.isLoading;
      state.errors = initialState.errors;
      state.data = initialState.data;
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = initialState.errors;
    },

    setError: (state, { payload }) => {
      state.isLoading = false;
      state.errors = payload;
    }
  }
});

export const {
  setInitialState,
  setIsLoading,
  setSuccess,
  setError
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectIsLoading = (state) => selectSlice(state).isLoading;
export const selectErrors = (state) => selectSlice(state).errors;
export const selectData = (state) => selectSlice(state).data;

export default slice.reducer;
